export const TODO_TASK_LISTS = 'TODO_TASK_LISTS'
export const TODO_TASK_ADD = 'TODO_TASK_ADD'
export const TODO_TASK_COMPLETED = 'TODO_TASK_COMPLETED'
